import React from "react";
import { Box, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import { BottomNextButton } from "components/common/BottomNextButton";
import CustomTypography from "components/common/CustomTypography";
import { useNavigate } from "react-router-dom";
import habit_30min_perday from "static/image/onboarding/habit_30min_perday.png";
import { userAtom } from "../../../../recoil/userAtom";
import { useRecoilValue } from "recoil";

export default function Habit_PS_5() {
  const navigate = useNavigate();
  const user = useRecoilValue(userAtom);

  const handleNext = () => {
    navigate(`/program-setup-2/habit/6`);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "70vh" }}>
      <Stack
        spacing={2}
        sx={{ flex: 1, display: "flex", flexDirection: "column" }}
      >
        <CustomTypography
          variant="Subtitle"
          fontWeight={700}
          sx={{
            color: theme.vars.palette.Content.Highlight,
          }}
        >
          {"하루 30분이면 충분합니다."}
        </CustomTypography>
        <CustomTypography
          variant="Subtitle"
          fontWeight={500}
          sx={{
            color: theme.vars.palette.Content.Strong,
          }}
        >
          {"활동지 분량은 언제든 코치 선생님과 조절할 수 있습니다."}
        </CustomTypography>

        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={habit_30min_perday}
            alt={"onboarding"}
            style={{
              maxWidth: "280px",
              objectFit: "contain",
            }}
          />
        </Box>
      </Stack>
      <BottomNextButton
        disabled={false}
        onClick={handleNext}
        text={"다음"}
        highlightBackground={true}
      />
    </Box>
  );
}
